module.exports = __webpack_public_path__ + "img/add.b559a919.svg";